export const truncateString = (str: string): string => {
  if (str?.length > 27) {
    return str.slice(0, 27) + '...';
  }
  return str;
};
